module.exports = __webpack_public_path__ + "static/media/cross.9d8faa8d.png";